export const variables = {
  API_URL: "https://variadb-backend-test.herokuapp.com/cards",
  API_URL_STORE: "https://variadb-backend-test.herokuapp.com/stores/",
  PLAYER_API_URL: "https://variadb-backend-test.herokuapp.com/players/",
  PHOT_URL: "http://localhost:8005/cards/images/",
  deckcards: [],
  itemcards: [],
  deckName: "",
};
